var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Backdrop } from '@spotify-internal/encore-web/core';
import { flyoutTransition } from '../config';
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const BackdropBlur = motion(Backdrop);
const backgroundAlpha = (opacity) => `var(--background-unsafe-for-small-text-highlight, rgba(0,0,0,${opacity}))`;
const closedState = {
    backdropFilter: 'blur(0px)',
    background: backgroundAlpha(0),
};
export const FlyoutMenuBackdrop = React.forwardRef((_a, ref) => {
    var { opened, children } = _a, props = __rest(_a, ["opened", "children"]);
    return (React.createElement(AnimatePresence, null, opened && (React.createElement(BackdropBlur, Object.assign({ key: "blur", layout: true }, props, { ref: ref, initial: closedState, animate: opened
            ? {
                backdropFilter: 'blur(15px)',
                background: backgroundAlpha(0.44),
            }
            : closedState, exit: closedState, transition: flyoutTransition }),
        React.createElement(motion.div, { key: "content", initial: {
                y: '-100%',
            }, animate: { y: opened ? '0%' : '-100%' }, exit: { y: '-100%' }, transition: flyoutTransition }, children)))));
});
//# sourceMappingURL=FlyoutMenuBackdrop.js.map